import { platformMeta } from '../../platformMeta';
import { SerializedSocialChannel, SocialPlatform } from '../../types';

/** The longest post caption the server takes (design d). */
export const REEL_CAPTION_MAX = 2200;

/** The longest reject reason the server takes, chips and notes together (design e). */
export const REEL_REASON_MAX = 500;

/**
 * Joins the picked chip labels and the notes into one reason (design e1), for example
 * "Too fast. Captions wrong. The cuts feel rushed." An empty result is undefined: no reason.
 */
export function joinReelRejectReason(chipLabels: string[], notes: string): string | undefined {
  const parts = [...chipLabels.map((label) => `${label}.`), notes.trim()].filter((part) => part !== '');
  return parts.length === 0 ? undefined : parts.join(' ');
}

/** A channel that can carry a draft post: it has a handle and the platform did not drop it. */
export function canChannelTakeReel(channel: SerializedSocialChannel): boolean {
  const hasHandle = channel.handle !== null && channel.handle !== '';
  return hasHandle && channel.status !== 'disconnected';
}

/** A channel that the platform dropped: it keeps its identity and needs a new sign-in. */
export function channelNeedsSignIn(channel: SerializedSocialChannel): boolean {
  return channel.status === 'disconnected' && channel.connection !== null;
}

/** The platforms the approve sheet picks first: every healthy channel (design d1). */
export function defaultReelPlatforms(channels: SerializedSocialChannel[]): SocialPlatform[] {
  return channels.filter(canChannelTakeReel).map((channel) => channel.platform);
}

/** The picked platform with the shortest caption limit, or undefined when none is picked. */
export function strictestCaptionPlatform(platforms: SocialPlatform[]): SocialPlatform | undefined {
  return platforms.reduce<SocialPlatform | undefined>(
    (best, one) =>
      best === undefined || platformMeta[one].captionLimit < platformMeta[best].captionLimit ? one : best,
    undefined
  );
}
